import type { ExtractPropTypes, PropType } from 'vue';
import type Link from './link.vue';

export type CustomLinkType =
  | 'edit'
  | 'add'
  | 'view'
  | 'del'
  | 'download'
  | 'upload'
  | 'import'
  | 'export'
  | 'maintenance';

/**
 * 内置 props.type
 */
export const customLinkType: Record<CustomLinkType, { icon: string; color?: string }> = {
  edit: { icon: 'icon-xiugai' },
  add: { icon: 'icon-xinzeng' },
  view: { icon: 'icon-chakan' },
  del: { icon: 'icon-shanchu', color: '#f56c6c' },
  download: { icon: '' },
  upload: { icon: 'icon-shangchuan1' },
  import: { icon: 'icon-daoru' },
  export: { icon: 'icon-daochu' },
  maintenance: { icon: 'icon-xitongweihu', color: '#1eb842' },
};

export const getLinkIcon = (type?: CustomLinkType, icon?: string) => {
  if (type) return customLinkType[type].icon;
  return icon;
};

export const LinkProps = {
  type: {
    type: String as PropType<CustomLinkType>,
    default: '',
  },
  color: String,
  hover: String,
  icon: String,
  disabled: Boolean,
};

export const linkEmits = {
  click: (evt: MouseEvent) => evt instanceof MouseEvent,
};

export type LinkEmits = typeof linkEmits;
export type LinkPropsType = ExtractPropTypes<typeof LinkProps>;
export type LinkInstance = InstanceType<typeof Link>;

export function darkenColor(color: string, level: number): string {
  // 解析颜色值
  let match = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i);
  if (!match) {
    // 如果不是rgb或rgba格式，则尝试转换为16进制
    color = hexToRgb(color);
    match = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i);
  }

  if (!match) {
    throw new Error('Invalid color format');
  }

  const [r, g, b, a] = match.slice(1).map((val, i) => (i === 3 ? parseFloat(val) : parseInt(val, 10)));

  // 计算加深后的颜色
  const darkenedR = Math.max(0, r - 255 * level);
  const darkenedG = Math.max(0, g - 255 * level);
  const darkenedB = Math.max(0, b - 255 * level);

  // 返回加深后的颜色
  return `rgba(${darkenedR}, ${darkenedG}, ${darkenedB}, ${a || 1})`;
}

// 辅助函数：将16进制颜色转换为rgb格式
function hexToRgb(hex: string): string {
  hex = hex.replace(/^#/, '');
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgb(${r}, ${g}, ${b})`;
}
